import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const [qrCode, setQrCode] = useState("");

	useEffect(() => {
		const fetchSession = async () => {
			if (!open || !whatsAppId) return;

			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`);
				if (data?.qrcode) {
					setQrCode(data.qrcode);
				}

				if (data?.status === "CONNECTED" && !data?.qrcode) {
					onClose();
				}
			} catch (err) {
				toastError(err);
			}
		};

		setQrCode("");
		fetchSession();

		const interval = setInterval(fetchSession, 2000);

		return () => clearInterval(interval);
	}, [open, whatsAppId, onClose]);

	useEffect(() => {
		if (!open || !whatsAppId) return;
		const socket = openSocket();

		socket.on("whatsappSession", data => {
			const sameSession =
				Number(data?.session?.id) === Number(whatsAppId);

			if (data.action === "update" && sameSession && data?.session?.qrcode) {
				setQrCode(data.session.qrcode);
			}

			if (
				data.action === "update" &&
				sameSession &&
				data?.session?.status === "CONNECTED" &&
				!data?.session?.qrcode
			) {
				onClose();
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [open, whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent>
				<Paper elevation={0}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						<QRCode value={qrCode} size={256} />
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
